import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';

@Component({
  selector: 'app-step-section-ii',
  templateUrl: './step-section-ii.component.html',
})
export class StepSectionIIComponent {
  constructor(public mdcService: MdcService) { }
}
